import React from 'react';
import MuiTooltip from '@mui/material/Tooltip';
import useTranslate from '../customHooks/useTranslate';

const Tooltip = props => {
    const { titleText, children, hideTooltip = false, ...restProps } = props;
    const trnTitle = useTranslate(titleText);
    if (hideTooltip) {
        return <>{children}</>;
    }

    return (
        <MuiTooltip
            title={trnTitle}
            placement='top'
            enterDelay={70}
            {...restProps}
        >
            {children}
        </MuiTooltip>
    );
};

export default Tooltip;
